<template>
    <div class="dashboard">
        <div class="container-fluid">
            <div class="row heading">
                <div class="col-sm-6">
                    <h1>{{ title }}</h1>
                </div>
            </div>
            <component v-for="section in getSections()" :key="section.name" :is="section.component">
                <component v-for="part in getSectionParts(section.name)"
                    :key="part.name" :slot="part.name" :is="part.component" :class="part.cssClass" v-bind="part.config"></component>
            </component>
        </div>
    </div>
</template>
<script>

export default {
    data() {
        return {

        }
    },

    computed: {
        dashboardConfig() {
            return this.config('dashboard', {});
        },

        title() {
            return _.get(this.dashboardConfig, 'title', 'Dashboard');
        },
    },

    mounted() {
        const title = this.config('cmsTitle', '');
        document.title = `${this.title || 'Dashboard'} - ${title}`;
    },

    methods: {
        getSectionParts(section) {
            const parts = _.chain(this.dashboardConfig)
                .get('parts', {})
                .toPairs()
                .map(([key, part]) => {
                    return {
                        name: key,
                        config: {},
                        cssClass: 'col',
                        section: 'default',
                        ...part,
                    }
                })
                .filter(part => part.section == section)
                .sortBy(['position'])
                .value()

            return parts;
        },

        getSections() {
            return _.get(this.dashboardConfig, 'sections', []);
        },
    }
}
</script>



// WEBPACK FOOTER //
// seventytwo/72cms-ui/src/components/DashboardComponent.vue